import { Form } from 'informed';
import React, { Fragment, useContext } from 'react';
import styled from 'styled-components';

import { useAuth0 } from '@auth0/auth0-react';
import { Button, Field } from '../../atoms';
import config from '../../config';
import { validateUrl } from '../../helpers';
import { ViewEditAdd } from '../../hocs';
import { ImageUpload, InlinePageTitle, Panel } from '../../molecules';
import { ApiClientContext } from '../../services';

function Employer(props) {
    const { data, errors, files, isExisting, handleSubmit, handleFileUpload, handleRemoveFileFromState } = props;
    const { user } = useAuth0();
    const { apiClient } = useContext(ApiClientContext);
    const { removeEmployerImage } = apiClient;
    const userName = user.name;

    const handleImageFileUpload = key => async (b64, file) => handleFileUpload(key, file, isExisting ? userName : undefined);

    const handleRemoveEmployerImageProps = (imageKey, stateKey) => ({
        dataForRemoval: { id: data.id, data: { updatedBy: userName, imageType: stateKey } },
        apiAction: removeEmployerImage,
        setData: updatedData => handleRemoveFileFromState(imageKey, stateKey, updatedData)
    });

    const updateForm = updatedFormState => {
        updatedFormState.updatedBy = userName;
        return handleSubmit(updatedFormState);
    };

    return (
        <Fragment>
            <InlinePageTitle title="Employer">
                <ButtonRow>
                    <Button
                        to={{
                            pathname: '/jobs/all',
                            search: `?employer=${data.slug}`
                        }}
                        icon="ArrowRight"
                    >
                        View Jobs
                    </Button>
                </ButtonRow>
            </InlinePageTitle>
            {!!data && !!data.name && (
                <Form onSubmit={updateForm} allowEmptyStrings>
                    {({ formState }) => (
                        <Fragment>
                            <Field
                                name="name"
                                initialValue={data.name}
                                required
                                errors={errors.Name || (formState.touched.name && formState.errors.name && [formState.errors.name])}
                                displayValueAs={<h2 style={{ marginBottom: 0 }}>{data.name}</h2>}
                                fieldType="text"
                                initialRenderType={'value'}
                                isTogglingEnabled={false}
                                handleSubmit={() => updateForm(formState.values)}
                                invalid={!!formState.errors.name}
                                disabled={true}
                            />
                            <Panel title="Employer Details">
                                <Field
                                    label="Url"
                                    name="slug"
                                    initialValue={data.slug}
                                    includeBefore={<Url>{config.website}for-women/employer/</Url>}
                                    required
                                    errors={errors.Slug || (formState.touched.slug && formState.errors.slug && [formState.errors.slug])}
                                    fieldType="text"
                                    initialRenderType={isExisting ? 'value' : 'field'}
                                    isTogglingEnabled={isExisting}
                                    handleSubmit={() => handleSubmit(formState.values)}
                                    invalid={!!formState.errors.slug}
                                />
                                <Field
                                    label="Website URL"
                                    name="websiteUrl" // TODO: Migrate this
                                    initialValue={data.websiteUrl}
                                    errors={errors.WebsiteUrl || (formState.touched.websiteUrl && formState.errors.websiteUrl && [formState.errors.websiteUrl])}
                                    fieldType="text"
                                    initialRenderType={isExisting ? 'value' : 'field'}
                                    isTogglingEnabled={isExisting}
                                    validate={validateUrl}
                                    handleSubmit={() => updateForm(formState.values)}
                                    invalid={!!formState.errors.websiteUrl}
                                />
                                <ImageUpload
                                    handleFileUpload={handleImageFileUpload('shareImageUploadInfo')}
                                    handleFileRemove={handleRemoveEmployerImageProps('shareImageUploadInfo', 'shareImage')}
                                    currentImage={data.shareImage}
                                    uploadedFilename={files.shareImageUploadInfo ? files.shareImageUploadInfo.name : ''}
                                    labelText="Share image" // TODO: Migrate this
                                    uploadButtonText="Choose share image"
                                    editButtonText="Edit share image"
                                    dialogTitle="Edit logo"
                                    dialogConfirmLabel="Save share image"
                                    previewImageAlt="Share image"
                                    showPreview
                                />
                                <Field
                                    label="Hide From Digital Display Ad Feeds" // TODO: Migrate this
                                    name="hideFromDigitalDisplayFeeds"
                                    initialValue={data.hideFromDigitalDisplayFeeds}
                                    displayValueAs={<span>{data.hideFromDigitalDisplayFeeds ? 'Yes' : 'No'}</span>}
                                    fieldType="checkbox"
                                    initialRenderType={isExisting ? 'value' : 'field'}
                                    isTogglingEnabled={isExisting}
                                    handleSubmit={() => updateForm(formState.values)}
                                    invalid={!!formState.errors.hideFromDigitalDisplayFeeds}
                                    hideOptionalLabel
                                    extraDetail="Removes Employers Jobs from DDA job feeds (ADMIN ONLY)"
                                />
                            </Panel>
                        </Fragment>
                    )}
                </Form>
            )}
        </Fragment>
    );
}

const Url = styled.span`
    opacity: 0.5;
    margin-right: -0.5rem;
`;

const ButtonRow = styled.div`
    a:first-child {
        margin-right: 0.5rem;
    }
`;

export default ViewEditAdd(Employer)({ domain: 'Employer' });
